module.exports = __webpack_public_path__ + "assets/img/zre2.680c5628.png";